import React, { FunctionComponent } from 'react'
import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import { useSaleSyncManager } from '../../../ng-compat/hooks'
import { $state } from '../../../ng-compat/imports'
import { STATES } from '../../../../../lib/routes'

interface ActionErroredSalesProps {
  close: () => void
}

export const ActionErroredSales: FunctionComponent<ActionErroredSalesProps> = ({
  close,
}) => {
  const saleSyncManager = useSaleSyncManager()

  const erroredSalesCount =
    saleSyncManager.erroredSalesCount + saleSyncManager.attemptedSalesCount

  return (
    <Modal onClose={close}>
      <ModalHeader>
        <T
          _str="{erroredSalesCount, plural, one {You have {erroredSalesCount} errored sale} other {You have {erroredSalesCount} errored sales}}"
          erroredSalesCount={erroredSalesCount}
        />
      </ModalHeader>
      <ModalContent>
        <T _str="Before you can switch registers, it’s important to have all your sales synced to our servers, otherwise your sales will be deleted and cannot be recovered." />
      </ModalContent>
      <ModalActions>
        <div className="vd-gtn-group">
          <Button
            onClick={() => {
              close()
              $state.go(STATES.STATUS)
            }}
          >
            <T
              _str="{erroredSalesCount, plural, one {View errored sale} other {View errored sales}}"
              erroredSalesCount={erroredSalesCount}
            />
          </Button>
        </div>
      </ModalActions>
    </Modal>
  )
}
